export default (config) => {
  const {
    userAgent: { browser, os },
  } = config;

  const needModules = [];
  const vendorHtml5 = require('mggp-vendor-html5');

  push('vendorHtml5', vendorHtml5);
  vendorHtml5.priority = 5; // need fore mobile os (android) to work mggp-vendor-hls
  push('vendorHtml', require('mggp-vendor-html'));
  push('pluginGa', require('mggp-plugin-ga'));
  push('pluginWss', require('mggp-plugin-wss'));
  push('pluginAudio', require('mggp-plugin-audio'));
  push('pluginQuality', require('mggp-plugin-quality'));
  push('pluginSubtitles', require('mggp-plugin-subtitles'));
  push('pluginKibana', require('mggp-plugin-kibana'));
  push('pluginKibanaWarnings', require('mggp-plugin-kibana-warnings'));
  push('pluginGemius', require('mggp-plugin-gemius'));
  push('pluginComscore', require('mggp-plugin-comscore'));
  push('vendorDash', require('mggp-vendor-dash'));
  push('pluginAd', require('mggp-plugin-ad'));
  push('vendorImg', require('mggp-vendor-img'));
  push('vendorIma', require('mggp-vendor-ima'));
  push('vendorYandex', require('mggp-vendor-yandex'));
  push('vendorVPAIDJS', require('mggp-vendor-vpaidjs'));
  push('vendorHls', require('mggp-vendor-hls'));
  push('pluginThumbnails', require('mggp-plugin-thumbnails-web'));
  push('pluginVclicks', require('mggp-plugin-vclicks'));
  push('pluginPartnersEvents', require('mggp-plugin-partners-events'));
  push('pluginLiveDvr', require('mggp-plugin-live-dvr'));
  push('pluginEpg', require('mggp-plugin-epg'));

  if (
    browser.name === 'Safari' &&
    os.name === 'Mac OS' &&
    parseFloat(os.version) >= 10.1
  ) {
    push('vendorHlsFairplay', require('mggp-vendor-hls-fairplay'));
    if (Number(browser.major) >= 10) {
      vendorHtml5.priority = 1;
    }
  }

  return needModules;

  function push(name, module) {
    needModules.push({ name, module });
  }
};
